import { getArtistsWithArtworksCount } from 'api/artists'
import { ArtistsIds } from 'constants/artists'
import { useQuery } from 'react-query'

export function useBlueChipArtists() {
  return useQuery({
    queryKey: ['blue-chip-artists'],
    queryFn: async () => {
      const { data } = await getArtistsWithArtworksCount([
        ArtistsIds.banksy,
        ArtistsIds.damienHirst,
        ArtistsIds.davidHockney,
        ArtistsIds.gerhardRichter,
      ])

      return data || []
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
}
